import { sendConsutantMail } from '@/API/repositories/mail';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRef, useState } from 'react';

const useConsultantEmail = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const [subject, setSubject] = useState();
	const [selectedFile, setSelectedFile] = useState();
	const bodyRef = useRef();

	const isLoading = hasUnfilledRequest(sendConsutantMail);

	const handleFileChange = (e) => {
		setSelectedFile(e.target.files[0]);
	};

	const sendEmail = async (e) => {
		e.preventDefault();

		const formData = new FormData();
		formData.append('subject', subject.value);
		formData.append('body', bodyRef.current.value);
		formData.append('file', selectedFile);

		const response = await makeRequest(sendConsutantMail.bind(null, formData));
		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		setSubject(null);
		bodyRef.current.value = '';
		setSelectedFile(null);
		return addMessage('Your email has been sent successfully', 'success');
	};

	return {
		subject,
		setSubject,
		bodyRef,
		handleFileChange,
		selectedFile,
		sendEmail,
		isLoading,
	};
};

export default useConsultantEmail;
